import React, { Component } from 'react';
import formDataSchema from '../../../schema/estimate-variance-report';
// import Select2 from '../../../../components/FormComponent/select2';
// import Inputlayer from '../../../../components/FormComponent/Input';
// import { filter, formData, dissableFormData } from '../../../../schema/apppointment';
import Datepicker from '../../../components/FormComponent/Date';
import DateRange from '../../../components/FormComponent/DateRange';
import Select2 from '../../../components/FormComponent/select2';
class Estimate_Variance_Report extends Component {
    render() {
        return (
            <div>
                <div className="card m-5 card-table">
                    <div className="card-header bg8">
                        <div className="clearfix">
                            <div className="float-left pt-1">
                                Estimate Variance Report
                            </div>
                            <div className=" row col-xl-9 float-right">
                                {formDataSchema.feilds
                                    .map((feild, key) => {
                                        if (feild.element === 'select2') {
                                            return (
                                                <div class="col-4">
                                                    <Select2
                                                        // Queuedata={formData}
                                                        selectdata={feild}
                                                        {...this.props}
                                                        {...this.state}
                                                    // onselectChanges={this
                                                    //     .formonChange
                                                    //     .bind(this)} 
                                                    />
                                                </div>
                                            )
                                        }
                                        if (feild.element === 'daterange') {
                                            return (
                                                <div
                                                    className={`${feild.className
                                                        ? feild.className
                                                        : 'col '} ${feild.name}`}
                                                    key={key}>
                                                    <DateRange

                                                        {...this.props}
                                                        {...this.state}
                                                    />

                                                </div>
                                            )
                                        }


                                        //              if (feild.element === 'date') {
                                        //     return (
                                        //         <div
                                        //             className={`${feild.className
                                        //                 ? feild.className
                                        //                 : 'col '} ${feild.name}`}
                                        //             key={key}>
                                        //              <p className="data-label text-white w-75 mb-1 pt-1 text-right pr-2">{feild.text}</p>
                                        //             <Datepicker
                                        //                 // Queuedata={filtereData}
                                        //                 selectdata={feild}
                                        //                 {...this.props}
                                        //                 {...this.state}
                                        //             // onselectChanges={this
                                        //             //     .onChange
                                        //             //     .bind(this)} 
                                        //             />
                                        //         </div>
                                        //     )

                                        // }
                                    })}
                            </div>
                        </div>

                    </div>
                    <div className="financial-table table-responsive">
                        <table className="table table-hover table-bordered mb-0" id="myTable">
                            <thead>
                                <tr>

                                    <td>S.no</td>
                                    <td>Patient Name</td>
                                    <td>Patient IP Number</td>
                                    <td>Discharge Date</td>
                                    <td>Payer Type</td>
                                    <td>Doctor Name</td>
                                    <td>Initial Counselled Amount (Rs.)</td>
                                    <td>Final Re-Counselled Amount (Rs.)</td>
                                    <td>Final Bill</td>
                                    <td>variance (Rs.)</td>
                                    <td>variance %</td>
                                    <td>Positive Variance</td>
                                    <td>Negative variance</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>01</td>
                                    <td>Sameer</td>
                                    <td>123456789</td>
                                    <td>03 April 2020</td>
                                    <td>Cash</td>
                                    <td>Sai</td>
                                    <td>100000</td>
                                    <td>200000</td>
                                    <td>250000</td>
                                    <td>50000</td>
                                    <td>25%</td>
                                    <td>Yes</td>
                                    <td>No</td>
                                </tr>
                                <tr>
                                    <td>02</td>
                                    <td>krishna</td>
                                    <td>123456789</td>
                                    <td>03 April 2020</td>
                                    <td>Insurance</td>
                                    <td>Prasad</td>
                                    <td>100000</td>
                                    <td>200000</td>
                                    <td>180000</td>
                                    <td>-20000</td>
                                    <td>-10%</td>
                                    <td>No</td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>04</td>
                                    <td>Sameer</td>
                                    <td>123456789</td>
                                    <td>03 April 2020</td>
                                    <td>Cash</td>
                                    <td>Sai</td>
                                    <td>100000</td>
                                    <td>200000</td>
                                    <td>250000</td>
                                    <td>50000</td>
                                    <td>25%</td>
                                    <td>Yes</td>
                                    <td>No</td>
                                </tr>
                                <tr>
                                    <td>05</td>
                                    <td>krishna</td>
                                    <td>123456789</td>
                                    <td>03 April 2020</td>
                                    <td>Insurance</td>
                                    <td>Prasad</td>
                                    <td>100000</td>
                                    <td>200000</td>
                                    <td>180000</td>
                                    <td>-20000</td>
                                    <td>-10%</td>
                                    <td>No</td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>06</td>
                                    <td>Sameer</td>
                                    <td>123456789</td>
                                    <td>03 April 2020</td>
                                    <td>Cash</td>
                                    <td>Sai</td>
                                    <td>100000</td>
                                    <td>200000</td>
                                    <td>250000</td>
                                    <td>50000</td>
                                    <td>25%</td>
                                    <td>Yes</td>
                                    <td>No</td>
                                </tr>
                                <tr>
                                    <td>07</td>
                                    <td>krishna</td>
                                    <td>123456789</td>
                                    <td>03 April 2020</td>
                                    <td>Insurance</td>
                                    <td>Prasad</td>
                                    <td>100000</td>
                                    <td>200000</td>
                                    <td>180000</td>
                                    <td>-20000</td>
                                    <td>-10%</td>
                                    <td>No</td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>08</td>
                                    <td>krishna</td>
                                    <td>123456789</td>
                                    <td>03 April 2020</td>
                                    <td>Cash</td>
                                    <td>Sai</td>
                                    <td>100000</td>
                                    <td>200000</td>
                                    <td>250000</td>
                                    <td>50000</td>
                                    <td>25%</td>
                                    <td>Yes</td>
                                    <td>No</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

export default Estimate_Variance_Report;